"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DayLabels = exports.ServiceLabels = exports.CohortDefaultIndividualServices = exports.CohortRequiredGroups = exports.ApptSources = exports.AttendanceStatuses = exports.ClientStatuses = exports.ApptKinds = exports.PlaceShortLabels = exports.PlaceLabels = exports.PlacesOfService = exports.ResourceTypeLabels = exports.ResourceTypes = exports.ServiceTypes = exports.SyntheticServiceTypes = exports.IndividualServiceTypes = exports.GroupServiceTypes = exports.ProviderRoles = exports.UserRoleLabels = exports.UserRoles = exports.AllDayOrder = exports.WeekdayOrder = exports.DayOfWeeks = exports.CohortDescriptions = exports.CohortLetters = void 0;
exports.isClientOverlapAllowed = isClientOverlapAllowed;
// ─── Cohorts ──────────────────────────────────────────────
exports.CohortLetters = ['A', 'B', 'C', 'D', 'E', 'F', 'G'];
exports.CohortDescriptions = {
    A: 'PHP + CPST',
    B: 'PHP only',
    C: 'IOP + CPST',
    D: 'IOP only',
    E: 'DT + OP',
    F: 'TBS + OP',
    G: 'OP only',
};
// ─── Days ─────────────────────────────────────────────────
exports.DayOfWeeks = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
exports.WeekdayOrder = ['MON', 'TUE', 'WED', 'THU', 'FRI'];
exports.AllDayOrder = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
// ─── Roles ────────────────────────────────────────────────
exports.UserRoles = ['ADMIN', 'PROVIDER', 'STAFF'];
// Display label per role. UI should prefer Provider; STAFF is legacy.
exports.UserRoleLabels = {
    ADMIN: 'Admin',
    PROVIDER: 'Provider',
    STAFF: 'Provider',
};
exports.ProviderRoles = [
    'THERAPIST',
    'PRESCRIBER',
    'NURSE',
    'UDS_TECH',
    'COMMUNITY_CM',
    'CPST_TBS_STAFF',
    'SUD_CM',
    'GROUP_STAFF',
];
// ─── Service types ────────────────────────────────────────
// One enum value per KIND of service. A clinic can run many concurrent group
// tracks for the same kind — those are separate Resource records, not separate
// enum values. Adding a 3rd IOP track tomorrow is a UI action, not a code change.
exports.GroupServiceTypes = [
    'PHP',
    'IOP',
    'CPST',
    'DT',
    'NURSING',
    'OP',
    'TBS',
];
exports.IndividualServiceTypes = [
    'THERAPY',
    'EM',
    'NURSING_INDIVIDUAL',
    'UDS',
    'SUD_CM',
    'CPST_TBS_INDIVIDUAL',
];
// Synthetic service type for staff-busy markers when leading a group.
exports.SyntheticServiceTypes = ['GROUP_FACILITATION'];
exports.ServiceTypes = [
    ...exports.GroupServiceTypes,
    ...exports.IndividualServiceTypes,
    ...exports.SyntheticServiceTypes,
];
/**
 * Client-side overlap policy — the single source of truth for both the
 * scheduling engine and ConflictService.
 *
 * A client may attend only one session at a time, with a SINGLE exception:
 * a UDS (urine screen) may overlap a Nursing Individual session (and vice
 * versa). Every other pair — including UDS with E&M, Therapy, or any group —
 * is forbidden.
 */
function isClientOverlapAllowed(a, b) {
    return ((a === 'UDS' && b === 'NURSING_INDIVIDUAL') ||
        (a === 'NURSING_INDIVIDUAL' && b === 'UDS'));
}
// ─── Resources ────────────────────────────────────────────────────────────
exports.ResourceTypes = [
    'PROVIDER',
    'COMMUNITY_PROVIDER',
    'GROUP',
    'ROOM',
    'STATION',
];
exports.ResourceTypeLabels = {
    PROVIDER: 'Provider',
    COMMUNITY_PROVIDER: 'Community Provider',
    GROUP: 'Group',
    ROOM: 'Room',
    STATION: 'Station',
};
// ─── Place of service ─────────────────────────────────────
// Physical location where the appointment occurs. Telehealth is NOT a place —
// it's a delivery mode validated separately (service.telehealthAllowed,
// resource.telehealthCapable, client.telehealthAllowed).
exports.PlacesOfService = ['OFFICE', 'HOME_COMMUNITY'];
exports.PlaceLabels = {
    OFFICE: 'Office',
    HOME_COMMUNITY: 'Home / Community',
};
exports.PlaceShortLabels = {
    OFFICE: 'Off',
    HOME_COMMUNITY: 'Comm',
};
exports.ApptKinds = ['GROUP', 'INDIVIDUAL'];
// ─── Status enums ─────────────────────────────────────────
exports.ClientStatuses = ['ACTIVE', 'ON_HOLD', 'DISCHARGED'];
exports.AttendanceStatuses = [
    'SCHEDULED',
    'ATTENDED',
    'LATE',
    'NO_SHOW',
    'CANCELLED_CLIENT',
    'CANCELLED_PROVIDER',
    'CANCELLED_CLINIC',
    'RESCHEDULED',
    'EXCUSED',
];
exports.ApptSources = ['SCHEDULER', 'MANUAL', 'IMPORT', 'RESCHEDULE', 'CRISIS'];
// ─── Cohort required-group templates ──────────────────────
// Each cohort needs these service KINDS. The engine picks specific group
// Resources at intake time based on capacity, preferred days, and client pins.
exports.CohortRequiredGroups = {
    A: ['PHP', 'CPST'],
    B: ['PHP'],
    C: ['IOP', 'CPST'],
    D: ['IOP'],
    E: ['DT', 'OP'],
    F: ['TBS', 'OP'],
    G: ['OP'],
};
// ─── Default required individual services per cohort ──────
exports.CohortDefaultIndividualServices = {
    A: ['THERAPY', 'EM', 'NURSING_INDIVIDUAL', 'UDS'],
    B: ['THERAPY', 'EM', 'NURSING_INDIVIDUAL', 'UDS'],
    C: ['THERAPY', 'EM', 'NURSING_INDIVIDUAL', 'UDS'],
    D: ['THERAPY', 'EM', 'NURSING_INDIVIDUAL', 'UDS'],
    E: ['THERAPY', 'EM', 'NURSING_INDIVIDUAL', 'UDS', 'SUD_CM'],
    F: ['THERAPY', 'EM', 'NURSING_INDIVIDUAL', 'UDS', 'SUD_CM', 'CPST_TBS_INDIVIDUAL'],
    G: ['THERAPY', 'EM', 'NURSING_INDIVIDUAL', 'UDS', 'SUD_CM'],
};
// ─── Service display labels ───────────────────────────────
exports.ServiceLabels = {
    PHP: 'PHP Group',
    IOP: 'IOP Group',
    CPST: 'CPST Group',
    DT: 'DT Group',
    NURSING: 'Nursing Group',
    OP: 'OP Group',
    TBS: 'TBS Group',
    THERAPY: 'Therapy',
    EM: 'E&M',
    NURSING_INDIVIDUAL: 'Nursing Individual',
    UDS: 'UDS',
    SUD_CM: 'SUD Case Mgmt',
    CPST_TBS_INDIVIDUAL: 'CPST/TBS Individual',
    GROUP_FACILITATION: 'Leading group',
};
exports.DayLabels = {
    MON: 'Mon',
    TUE: 'Tue',
    WED: 'Wed',
    THU: 'Thu',
    FRI: 'Fri',
    SAT: 'Sat',
    SUN: 'Sun',
};
//# sourceMappingURL=enums.js.map